import { Button } from '@bfa/base-ui';
import { useRouter } from 'next/router';
import React from 'react';
import { AnalyticsLink } from '../../../../../../../components/Analytics';
import { REFRESHMENTS_URLS } from '../../../../../../../constants';
import { SUBSCRIBED_LANDING_NEXT_SHIPMENT_SUMMARY_SECTION_EVENTS as EVENTS } from '../../../../../../../utils/analytics/events';
import { getMonthName } from '../../../../../../../utils/dates';
import { getRefreshmentsUrlWithHash } from '../../../../../../../utils/redirectTo';
import { replacePropertyInStr } from '../../../../../../../utils/subscription';
import { ButtonsWrapper, ButtonWrapper, Container, Description, SubTitle, SummaryContainer, SummaryHeaderContainer, SummaryItemsList, Title, } from '../../DetailedNextShipmentSummary.styled';
import SummaryItem from '../SummaryItem';
// If the "tentativeNextDeliveryDate" field does not exist for any reason (it shouldn't happen at this point),
// the default value of the next delivery month is the next month.
var DEFAULT_DELIVERY_MONTH = new Date().toISOString();
var ShipmentSummary = function (_a) {
    var _b, _c;
    var content = _a.content, items = _a.items;
    var route = useRouter();
    var deliveryDate = ((_c = (_b = items === null || items === void 0 ? void 0 : items[0]) === null || _b === void 0 ? void 0 : _b.tentativeNextDeliveryDate) === null || _c === void 0 ? void 0 : _c.toString()) || DEFAULT_DELIVERY_MONTH;
    var monthName = getMonthName(deliveryDate);
    var subtitle = replacePropertyInStr((content === null || content === void 0 ? void 0 : content.subtitle) || '', {
        monthName: monthName,
    });
    var UPSELL_BY_CATEGORY_URL = getRefreshmentsUrlWithHash('UpsellByCategories');
    return (React.createElement(Container, { "data-testid": "shipment-summary-section" },
        React.createElement(SummaryContainer, null,
            React.createElement(SummaryHeaderContainer, null,
                React.createElement(Title, null, content === null || content === void 0 ? void 0 : content.title),
                React.createElement(SubTitle, null, subtitle),
                React.createElement(Description, null, content === null || content === void 0 ? void 0 : content.description)),
            React.createElement(SummaryItemsList, null, items.map(function (item) { return (React.createElement(SummaryItem, { key: item.id, item: item })); }))),
        React.createElement(ButtonsWrapper, null,
            React.createElement(ButtonWrapper, null,
                React.createElement(AnalyticsLink, { eventData: EVENTS.CLICK_ON_UPSELL_LINK, href: UPSELL_BY_CATEGORY_URL, passHref: true },
                    React.createElement(Button, { variant: "primary", "data-testid": "add-more-essentials-button", small: true }, content === null || content === void 0 ? void 0 : content.primaryButtonText))),
            React.createElement(AnalyticsLink, { eventData: EVENTS.CLICK_ON_MANAGE_ITEMS_LINK, href: REFRESHMENTS_URLS.MANAGE_ITEMS, passHref: true },
                React.createElement(Button, { variant: "secondary", "data-testid": "manage-shipments-button", small: true }, content === null || content === void 0 ? void 0 : content.secondaryButtonText)))));
};
export default ShipmentSummary;
